import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexModule } from '@ngbracket/ngx-layout';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModalModule } from '@eg/ui';
import { EditBookingConfirmationComponent } from './edit-booking-confirmation.component';

@NgModule({
  declarations: [EditBookingConfirmationComponent],
  imports: [CommonModule, TranslocoModule, FlexModule, AngularSvgIconModule.forRoot(), ModalModule],
  exports: [EditBookingConfirmationComponent],
})
export class EditBookingConfirmationModule {}
